import { defineComponent, ref, computed } from '@vue/composition-api';
import __vue_component__$1 from '../SdsIcon/SdsIcon.vue.js';
import __vue_component__ from '../SdsBaseInput/SdsBaseInput.vue.js';

var script = defineComponent({
    name: 'SdsInputSearch',
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: undefined,
        },
        label: {
            type: String,
            required: true,
        },
        autocomplete: {
            type: String,
            required: false,
            default: undefined,
        },
        placeholder: {
            type: String,
            required: false,
            default: undefined,
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false,
        },
        dataTestId: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    model: {
        prop: 'value',
        event: 'update:value',
    },
    emits: [
        'update:value',
        'focus',
        'blur',
        'click',
        'keydown',
        'keypress',
        'keyup',
        // Exposed if we need analytics or some reaction to this
        'cleared',
    ],
    setup: function () {
        var baseInputRef = ref();
        var htmlInputIdRef = computed(function () { var _a, _b; return (_b = (_a = baseInputRef.value) === null || _a === void 0 ? void 0 : _a.inputElementRef) === null || _b === void 0 ? void 0 : _b.id; });
        return {
            baseInputRef: baseInputRef,
            htmlInputIdRef: htmlInputIdRef,
        };
    },
    components: {
        SdsBaseInput: __vue_component__,
        SdsIcon: __vue_component__$1,
    },
});

export default script;
